import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NodeInstanceModel } from '../../../../models/node/node-instance.model';
import { IProjectModel } from '../../../../models/project/project.model';
import { IWorkspaceInstanceModel } from '../../../../models/workspace/workspace-instance.model';
import { ITestStepInstanceModel } from '../../../../models/test-step/test-step-instance.model';

@Component({
  selector: 'app-edit-panel-attachments-pane',
  templateUrl: './edit-panel-attachments-pane.component.html',
  styleUrls: ['./edit-panel-attachments-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditPanelAttachmentsPaneComponent {
  @Input() attachmentsCount = 0;
  @Input() isDoView = false;
  @Input() isTestStepSelected = false;
  @Input() isPanelExpanded: boolean | null = null;
  @Input() selectedNode?: NodeInstanceModel | null;
  @Input() selectedTestStep?: ITestStepInstanceModel | null;
  @Input() selectedProject?: IProjectModel | null;
  @Input() selectedWorkspace?: IWorkspaceInstanceModel | null;

  @Output() stepAttachmentSaved = new EventEmitter<any>();
}
